﻿import * as LogService from '../core/services/logservice/log.service';
import * as HttpDataServiceBase from '../core/httpdataservicebase';
import * as MessageBarService from '../core/services/messageBarService/messageBar.service';
import * as Model from '../models/models';
import IAppSettings from '../../iApp.settings';

export class SubmissionRepository extends HttpDataServiceBase.DataServiceBase<Model.ISubmission> {

    private appSettings: IAppSettings;

    public static $inject = ['$q', '$http', 'logService', 'appSettings', 'messageBarService'];
    constructor($q: ng.IQService, $http: ng.IHttpService, logger: LogService.ILogService, appSettings: any, messageBarService: MessageBarService.MessageBarService) {
        super($q, $http, logger, messageBarService, appSettings.apiPath + '/submissions');
        this.appSettings = appSettings;
    }

    protected transformInboundModel(model: Model.ISubmission): Model.ISubmission {
        // transform effective date
        const effectiveDate = model.policyEffectiveDate as any as string;
        // noinspection TsLint
        if (effectiveDate != null)
            model.policyEffectiveDate = new Date(effectiveDate);

        return model;
    }

    public submissionSearch(searchCriteria: Model.ISubmissionSearchCriteria): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/submissions/search`;

        return this.$http.post(url, searchCriteria)
            .then((response: ng.IHttpPromiseCallbackArg<Model.ISubmission[]>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }

    public getSubmissionsByPolicyholderId(policyholderId: string): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/policyholder/${policyholderId}/submissions`;

        return this.$http.get(url)
            .then((response: ng.IHttpPromiseCallbackArg<Model.ISubmission[]>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }

    public evaluateSubmissionForUnderwriting(submissionId: string): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/submissions/evaluateforunderwriting/${submissionId}`;
        return this.$http.post(url, undefined)
            .then((response: ng.IHttpPromiseCallbackArg<Model.ISubmission>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }

    // this method does not wait for a submission response
    public finalizeSubmissionWithNoWait(submissionId: string): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/submissions/finalize/${submissionId}`;
        const result = this.$http.post(url, undefined, { bypassErrorPage: true} as any)
            .then((response: ng.IHttpPromiseCallbackArg<any>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallback<any>) => this.errorHandler(error));
        return result;
    }

    public acceptSubmissionAsync(submissionId: string): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/submissions/accept/${submissionId}`;
        return this.$http.post(url, undefined)
            .then((response: ng.IHttpPromiseCallbackArg<Model.ISubmission>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }

    public getSubmissionProfile(submissionId: string): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/submissions/${submissionId}/profile`;
        return this.$http.get(url)
            .then((response: ng.IHttpPromiseCallbackArg<Model.ISubmissionProfile>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }

    public getCurrentUsersSubmissions(): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/currentuser/submissions`;

        return this.$http.get(url)
        .then((response: ng.IHttpPromiseCallbackArg<Model.ISubmission[]>) => this.successHandler(response))
        .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }
}